const exportJSONToCSV = (value) => {
  //takeOut certain key values from object
  const objArray = value.map(
    ({
      created,
      redisKey,
      topupUrl,
      sessionId,
      idString,
      id,
      topupAccount,
      modified,
      ...rest
    }) => ({ ...rest })
  );

  const arr = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  const str =
    `${Object.keys(arr[0])
      .map((value) => `"${value}"`)
      .join(",")}` + "\r\n";
  const csvContent = arr.reduce((st, next) => {
    st +=
      `${Object.values(next)
        .map((value) => `"${value}"`)
        .join(",")}` + "\r\n";
    return st;
  }, str);
  const element = document.createElement("a");
  element.href = "data:text/csv;charset=utf-8," + encodeURI(csvContent);
  element.target = "_blank";
  element.download = "export.csv";
  element.click();
};

export const KEYCLOAK_TOKEN = "KEYCLOAK_TOKEN";

export function handleRewardTypes(rewardType, amount) {
  if (
    rewardType?.toLowerCase() === "airtime" ||
    rewardType?.toLowerCase() === "mobile money"
  ) {
    return `GHS ${amount} - ${rewardType}`;
  }

  return rewardType;
}

export default {
  exportJSONToCSV,
};
